import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";

import routes from "../../constants/routes";
import SecondaryButton from "../../widgets/Buttons/SecondaryButton";
import styles from "./StudentDetails.module.scss";

const StudentDetailsLayout = ({
  vertical,
  studentData,
  studentInfoSlot,
  callActionSlot,
  operationGroups,
  title = "Student Details",
  backRoute = routes.manageStudent.root,
  operationsTitle = "Student Operations",
  noDataMessage = "No student data found.",
}) => {
  const navigate = useNavigate();

  if (!studentData) {
    return (
      <div className={styles.wrapper}>
        <p className={styles.noData}>{noDataMessage}</p>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerBox}>
        <h2 className={styles.title}>{title}</h2>
        {vertical !== undefined && (
          <div className={styles.badge}>
            {vertical}
          </div>
        )}
        <div className={styles.headerSpacer} />
        {callActionSlot && (
          <div className={styles.headerActionWrapper}>{callActionSlot}</div>
        )}
        <SecondaryButton
          onClick={() => navigate(backRoute)}
          className={styles.headerButton}
        >
          Back
        </SecondaryButton>
      </div>

      <div className={styles.studentDetailsContent}>
        {studentInfoSlot}
        {operationGroups?.length ? (
          <Paper elevation={0} className={styles.actionsPanel}>
            <Typography component="h3" className={styles.operationsTitle}>
              {operationsTitle}
            </Typography>
            <Box className={styles.operationButtons}>
              {operationGroups.map((group) => (
                <React.Fragment key={group.title}>
                  {group.content}
                </React.Fragment>
              ))}
            </Box>
          </Paper>
        ) : null}
      </div>
    </div>
  );
};

export default StudentDetailsLayout;
